export const FETCH_ADMIN_INFO = 'FETCH_ADMIN_INFO';


export const fetchadmininfo = (admininfo) => ({
    type: FETCH_ADMIN_INFO,
    payload: admininfo,
  });